<template>
    <div class="login-container">
        <language-selector class="language-switch" />
        <div class="login_box">
            <div class="title">
                {{ $t('components.login.title') }}
            </div>
            <div class="form">
                <el-tabs v-model="activeName">
                    <el-tab-pane :label="$t('components.login.tabs.passwordLogin')" name="first">
                        <el-form @submit.native.prevent :model="numberValidateForm" :rules="rules" ref="numberForm" label-width="0px">
                            <div class="btn">
                                <el-form-item prop="phone">
                                    <el-input
                                        autocomplete="new-password"
                                        :placeholder="$t('components.login.form.phoneOrUsername')"
                                        v-model.number="numberValidateForm.phone">
                                        <i slot="prefix">
                                            <img src="@/assets/phone.png" alt="">
                                        </i>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="btn">
                                <el-form-item prop="password">
                                    <el-input
                                        autocomplete="new-password"
                                        type="password"
                                        :placeholder="$t('components.login.form.password')"
                                        v-model="numberValidateForm.password">
                                        <i slot="prefix">
                                            <img src="@/assets/password.png" alt="">
                                        </i>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="btn">
                                <el-form-item prop="vercode">
                                    <el-input
                                        :placeholder="$t('components.login.form.verificationCode')"
                                        v-model="numberValidateForm.vercode">
                                        <i slot="prefix">
                                            <img src="@/assets/vercode.png" alt="">
                                        </i>
                                    </el-input>
                                </el-form-item>
                                <img @click="refreshCode" class="img" :src="captchaimg" alt="">
                            </div>
                        </el-form>
                        <div class="loginbtn">
                            <el-button :loading="loading" @click="login" type="primary">
                                {{ $t('components.login.form.login') }}
                            </el-button>
                            <div class='footer-box'>
                                <div class="auth-links">
                                    <span class="register" @click="forgetPassWord">
                                        {{ $t('components.login.form.forgotPassword') }}
                                    </span>
                                    <el-divider direction="vertical"></el-divider>
                                    <span @click="register" class="register">
                                        {{ $t('components.login.form.register') }}
                                    </span>
                                </div>
                                <div class="cert-download" :class="{ 'en-newline': $i18n.locale === 'en' }">
                                    <template v-if="$i18n.locale === 'cn'">
                                        <el-divider direction="vertical"></el-divider>
                                    </template>
                                    <span @click="sslClick" class="register">
                                        {{ $t('components.login.form.downloadCert') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import {getCaptcha} from '@/api/login/index.js'
import {getFlUserPermission , queryPartyInfo , showFlUserRole, passwordChange } from '@/api/index.js'
import { getAuth, setAuth, setTenantId , setPartyInfo, setIndex , setUserRole} from '@/utils/auth.js'
import sslDialog from '@/components/AiErSSL.vue';
import crypto from '@/utils/crypto.js'
import LanguageSelector from '@/layout/components/LanguageSelector.vue'

export default {
    components: {
        sslDialog,
        LanguageSelector
    },
    data() {
        return {
            activeName: 'first',
            numberValidateForm: {
                phone: '',
                password: '',
                vercode: '',
            },
            rules: {
                phone: [
                    { required: true, message: this.$t('components.login.rules.phoneRequired') }
                ],
                password: [
                    { required: true, message: this.$t('components.login.rules.passwordRequired') }
                ],
                vercode: [
                    { required: true, message: this.$t('components.login.rules.codeRequired') }
                ]
            },
            captchaimg:'',
            loading: false,
            key: '',
            sslDialogVisible: false,
            noFooter: true
        }
    },
    created() {
        this.getCaptcha()
        sessionStorage.removeItem("Auth")
        sessionStorage.removeItem("showname")
        sessionStorage.removeItem("tourist")
    },
    methods:{
        sslClick() {
            this.$DialogSSL(this)
        },
        async login() {
            try {
                const valid = await this.$refs.numberForm.validate();
                if (valid) {
                    this.loading = true;
                    let loginData = {
                        "captcha": this.numberValidateForm.vercode,
                        "checkKey": this.key,
                        "password": crypto.set(this.numberValidateForm.password),
                        "username": crypto.set( this.numberValidateForm.phone)
                    }
                    await this.$store.dispatch('user/login', loginData).then((res) => {
                        this.queryPartyInfo()
                        this.loading = false
                        this.$message.success(this.$t('components.login.messages.loginSuccess'))
                    }).catch((res) => {
                        this.refreshCode()
                        this.loading = false
                    })
                }
            } catch (error) {
                this.$message.error(this.$t('components.login.messages.loginFailed'))
            }
        },
        async getCaptcha(){
            this.key = parseInt(Math.random()* 100000) + 1
            await getCaptcha(this.key).then(res=>{
                let resdata = res.data
                this.captchaimg = resdata.result
            })
            .catch(res=>{
                
            })
        },
        forgetPassWord() {
            this.$router.push({
                name: "ForgetPassWord"
            })
        },
        async passwordChange() {
            let params = {

            }
            await passwordChange().then(res=>{

            })
        },
        register() {
            this.$router.push({
                name: "Register"
            })
        },
        refreshCode() {
            this.getCaptcha()
        },
        async queryPartyInfo() {
            await queryPartyInfo().then(res=>{
                if(res.data.success) {
                    setPartyInfo(JSON.stringify(res.data.result))
              
                    if(res.data.result == null) {
                        this.$router.push({
                            name: 'Select'
                        })
                        setTenantId(0)
                        sessionStorage.setItem('tourist',true)
                    
                    } else {
                        sessionStorage.setItem('tourist',false)
                        if(res.data.result.length==1){
                            let id = res.data.result[0].id
                            let name = res.data.result[0].name
                            let uploadUrl = res.data.result[0].uploadUrl
                            let nameEn = res.data.result[0].nameEn
                            sessionStorage.setItem('showname',name)
                            sessionStorage.setItem("uploadUrl", uploadUrl);
                            sessionStorage.setItem("nameEn", nameEn);
                            
                            setTenantId(id)
                            this.showFlUserRole(id)
                            this.getFlUserPermission(id)
                        } else if(res.data.result.length>1) {
                            setIndex('index')
                            sessionStorage.setItem('showHeader',false)
                            this.$router.push({
                                name: 'Select',
                                query: {
                                    more: 1
                                }
                            })
                        } 
                    }
                    
                    
                    
                }
            })
            .catch(res=>{
                
            })
        },
        async getFlUserPermission(id,name) {
            await getFlUserPermission(id).then(res=>{
                setAuth(JSON.stringify(res.data.result))
                this.Auth =JSON.parse(getAuth()) 
                setIndex('')
                this.$router.push({
                    name: 'Select'
                })
            })
            .catch(res=>{
                
            }) 
        },
        async showFlUserRole(id) {
            await showFlUserRole(id).then(res=>{
                
                if(res.data.success) {
                    setUserRole(JSON.stringify(res.data.result))
                }
            })
            .catch(res=>{
                
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.login-container {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    
    .language-switch {
        position: fixed;
        top: 20px;
        right: 40px;
        z-index: 1000;
    }
}
.login_box{
    position: relative;
    height: 100%;
    background-color: #fff;
    width: 400px;
    padding: 0 100px;
    margin: 0 auto;
    .title{
        color: #484848;
        font-size: 40px;
        font-weight: 700;
        padding-top: 140px;
        text-align: center;
    }
    .form{
        margin-top: 70px;
        .btn:first-child{
            margin-top: 40px;
        }
        .btn:last-child{
            display: flex;
            ::v-deep .el-input {
                width: 204px;
                margin-right: 16px;
            }
            .img{
                width:144px;
                height: 40px;
                background-color: #ccc;
                cursor: pointer;
            }
            
        }
        .btn{
            margin-bottom: 30px;
        }
        .forgetpsd{
            text-align: right;
            font-size: 14px;
            color: #484848;
            cursor: pointer;
            overflow: hidden;
        }
        .loginbtn{
            margin-top: 40px;
            cursor: pointer;
            width: 100%;
            ::v-deep .el-button {
                width: 100%;
                height: 50px;
                background-color: #0B80EA;
                font-size: 18px;
            }
            .footer-box{
                margin-top: 20px;
                text-align: center;
                font-size: 16px;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;

                .auth-links {
                    display: inline-flex;
                    align-items: center;
                }

                .cert-download {
                    display: inline-flex;
                    align-items: center;

                    &.en-newline {
                        width: 100%;
                        justify-content: center;
                        margin-top: 10px;
                    }
                }

                .register {
                    margin: 0 5px;
                    color: #484848;
                    cursor: pointer;
                }

                .el-divider--vertical {
                    margin: 0 8px;
                }
            }
            
        }
        // margin-top: 30px;
        ::v-deep .el-tabs__item{
            color: #9A9A9A;
            font-size: 20px;
            font-weight: 700;
            height: 50px;
        }
        ::v-deep .el-tabs__item.is-active{
            color: #0B80EA;
            font-size: 20px;
            font-weight: 700;
        }
        ::v-deep .el-tabs__active-bar{
            color: #484848;
            background-color: #0B80EA;
            height: 5px;
        }
        ::v-deep .el-input__prefix, .el-input__suffix{
            display: flex;
            align-items: center;
            padding-left: 15px;
        }
        ::v-deep .el-input--prefix .el-input__inner{
            padding-left: 50px;
        }
        ::v-deep .el-form-item__content{
            line-height: 0;
        }
    }
}
</style>
